import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { rejectCollectionTriageClipApi } from '@repo/sdk';
import { z } from 'zod';

export function registerRejectTriageClip(server: McpServer): void {
  server.registerTool(
    'reject_triage_clip',
    {
      title: 'Reject a triage clip (admin)',
      description:
        'Reject a clip in a collection triage queue. Requires an admin session. Set alsoChallenge to true to also reject the parent challenge.',
      inputSchema: {
        collectionId: z.number().int().positive(),
        clipId: z.number().int().positive(),
        reason: z.string().min(1).max(500),
        alsoChallenge: z.boolean(),
      },
    },
    async ({ collectionId, clipId, reason, alsoChallenge }) => {
      const { data } = await rejectCollectionTriageClipApi({
        collectionId,
        clipId,
        reason,
        alsoChallenge,
      });
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? null) }],
      };
    },
  );
}
